import styled from "@emotion/styled";

import Button from "metabase/core/components/Button";
import { color } from "metabase/lib/colors";
import { space } from "metabase/styled-components/theme";

export const StyledDeleteButton = styled(Button)`
  :hover {
    cursor: pointer;
    color: ${color("danger")};
    background-color: ${color("bg-medium")};
  }
`;

export const ModalMessage = styled.div`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  button + button {
    margin-left: 1rem;
  }
  .action-spin {
    margin-left: ${space(1)};
  }
`;
